export const CONTACT_PANEL_MODE = {
  COLLAPSED: 'collapsed',
  OPEN: 'open',
};

export const CONTACT_PANEL_TAB = {
  FIND: 'find',
  CREATE: 'create',
};

export const CONTACT_PANEL_TAB_BUTTONS = [
  { value: CONTACT_PANEL_TAB.FIND, label: 'Find existing' },
  { value: CONTACT_PANEL_TAB.CREATE, label: 'Create new' },
];

export const CONTACT_SEARCH_MIN_CHARS = 2;

// Defaults for a contact created from a borrower (per STP-26 decisions).
export const NEW_CONTACT_LIFECYCLE_STAGE = 'ActiveBorrower';
export const NEW_CONTACT_SOURCE = 'LoanApplication';
